import { fontSizes } from '@/tools/consts';
import { mutationTypes, actionTypes, errorTypes } from '@/types';

export default function setFontSize({ commit, dispatch }, { size }) {
	if (Object.values(fontSizes).includes(size)) {
		commit(mutationTypes.setFontSize, { size });
	} else {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.setFontSize) });
	}
}
